<template>
  <div>
    <a-modal
      :title="`文章列表 - ${title}`"
      :visible="visible"
      width="50%"
      @cancel="handleCancel"
    >
      <a-table row-key="id" :columns="viewColumns" bordered :loading="loading" :data-source="data" :pagination="false" class="article-table">
        <template slot="title" slot-scope="text, record">
          <a @click="handlePreViewAutoArticle(record)"> {{ record && record.title }} </a>
        </template>

        <template slot="project" slot-scope="text, record">
          <span color="#1890ff">{{ getOrg(record) }}</span>
        </template>

        <template slot="articleTypeOne" slot-scope="text, record">
          <span>{{ record && record.articleTypeOne && record.articleTypeOne.type_name }}</span>
        </template>

        <template slot="operation" slot-scope="text, record, index">
          <a v-if="status !== '1'" @click="handleDelAutoArticle(record, index)">删除</a>
          <a style="margin-left: 10px;" @click="toEditPage(record)">编辑</a>

        </template>
      </a-table>

      <template slot="footer">
        <a-row type="flex" justify="space-between">
          <div>
            注： {{ notice[status] }}
          </div>
          <div>
            <a-button v-if="status === '0'" type="danger" :loading="loadingMatchAgain" @click="handleMatchAgain(record)">重新匹配</a-button>
            <a-button v-if="status !== '1'" type="primary" :loading="loadingPass" @click="handlePass(record)">通过</a-button>
            <a-button @click="handleCancel">取消</a-button>
          </div>
        </a-row>
      </template>
    </a-modal>

    <!-- PC 内容预览 -->
    <a-modal :width="1200" :destroyOnClose="true" :visible="previewPc" :footer="null" @cancel="previewPc = false" class="preview-modal">
      <div class="pc-container">
        <div v-html="preViewContent"></div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { ref, reactive, onMounted, toRefs, getCurrentInstance } from '@vue/composition-api'
import { viewColumns } from '../business/filialeList'
import api from '@/api/'
import { strategyCommand } from '@/views/article/components/Article/business/tableLogic.js'

export default {
  props: {
    rawPlatList: {
      type: Array,
      default: () => []
    },
    platformList: {
      type: Array,
      default: () => []
    },
  },

  setup(props, { root }) {
    // 获取当前实例
    const _this = getCurrentInstance()

    const state = reactive({
      title: '',
      status: null,
      labelId: null,
      visible: false,
      loading: false,
      loadingMatchAgain: false,
      loadingPass: false,
      data: [],
      viewColumns,
      notice: {
        '0': '点击通过后系统会自动关联标签至文章',
        '1': '通过后不能再修改，如果需要取消，请点击编辑按钮到文章编辑页操作',
        '2': '点击重新匹配后，下次匹配会产生新的匹配记录，原记录可以继续操作',
      },
      previewPc: false,
      preViewContent: '',
    })

    const methods = {
      open(data, tab) {
        tab && tab.name && (state.title = tab.name)
        tab && tab.name && (state.status = tab.key)
        this.data = data && data.autoArticle || []
        this.labelId = data && data.id
        this.visible = true
      },
       handleDelAutoArticle(record, index) {
        this.$confirm({
        title: '确定要删除本行数据?',
        cancelText: '取消',
        okText: '确定删除',
        async onOk() {
          await api.autoLabelAudit({
            label_id: state.labelId,
            article_ids: [record.id],
            audit: 'delete' // 操作：  pass通过  no重新匹配 delete删除
          }).then((res) => {
            if (res.code === '000000') {
              _this.$message.success('已删除')
              _this.data.splice(index, 1)
            }
          })
        },
      })
      },
      async handleMatchAgain() {
        await api.autoLabelAudit({
            label_id: state.labelId,
            article_ids: _this.data.map(item => item.id),
            audit: 'no' // 操作：  pass通过  no重新匹配 delete删除
          }).then(() => {
            _this.$message.success('操作成功')
            _this.handleCancel()
            _this.$emit('update')
          })
      },
      async handlePass() {
        await api.autoLabelAudit({
            label_id: state.labelId,
            article_ids: _this.data.map(item => item.id),
            audit: 'pass' // 操作：  pass通过  no重新匹配 delete删除
          }).then(() => {
            _this.$message.success('操作成功')
            _this.handleCancel()
            _this.$emit('update')
          })
      },
      handleCancel() {
        this.visible = false
      },
      getOrg(record) {
        const obj = this.rawPlatList.find(item => String(item.project) === record.project && String(item.type) === record.type && String(item.staff_style) === record.staff_style)
        return obj ? obj.org : ''
      },
      handlePreViewAutoArticle(record) {
        this.getArticleDetail(record.id)
        this.previewPc = true
      },
      async getArticleDetail(id) {
        const res = await api.detailArticle({ id })
        const { content } = res.data.article
        state.preViewContent = content
      },
      getLineID(record) {
        const obj = this.platformList.find(item => String(item.project) === record.project && String(item.type) === record.type && String(item.staff_style) === record.staff_style)
        return obj ? obj.id : ''
      },
      // 转到编辑页面
      toEditPage(record) {
        strategyCommand['edit'].call(_this, record)
      },
    }

    return {
      ...toRefs(state),
      ...methods
    }
  }
}
</script>

<style lang="less" scoped>
.article-table{
  max-height: 450px;
  overflow-y: auto;
}
/deep/.ant-table-title{
  padding: 0;
}

.preview-modal /deep/.ant-modal-content{
  height: 650px;
  overflow-y: auto;
}
</style>
